import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../../scss/newdashboard.scss';
// import { Encoding } from "../../../helpers/CodingHelper";
import { TwitterTimelineEmbed } from 'react-twitter-embed';
// import InstagramEmbed from "react-instagram-embed";
import { LinkPreview } from '@dhaiwat10/react-link-preview';
// import { Link } from "react-router-dom";
import { Spin, notification } from 'antd';
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { Modal, Button } from 'antd';
import CompanyPropsHelper from '../../../helpers/CompanyPropsHelper';
import SetThemeColor from "../../../utils/setThemeColor";

import f2 from '../Design/img/buck3.png';
import img10 from './images/image-10.png';
import overlay from './img/SquareWallpaper.png';
// import 'animate.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css'; // You can also use <link> for styles

import athlete1 from './img/athlete1.png';
import gotit1 from './img/Ownership-A.png';
import gotit2 from './img/Mint-Guarantee.png';
import gotit3 from './img/Multi-platform.png';
import gotit4 from './img/Payout_S.png';
import silverlandry from './img/gaia-mi.png';

import Bengals from './img/Bengals.png';
import Buckslogo from './img/Buckslogo.png';
import Kings from './img/Kings.png';
import Chiefs from './img/Chiefs.png';
import Chargers from './img/Chargers.png';
import Pistons from './img/Pistons.png';
import Jags from './img/Jags.png';
import Ravens from './img/Ravens.png';
import PFHOF from './img/PFHOF.png';
import DraftKings from './img/DraftKings.png';
import pusherlogo from './img/pusherlogo.svg';
import MLBPlayers from './img/MLBPlayers.png';
import MemberNFT from './img/MemberNFT.png';
import chase from './img/CHASE.png';
import metabilialearn from './img/metabilialearn.png';
import one4onemetabiliagraphic from './img/one4onemetabiliagraphic.png';
import HoustonTexans from './img/Houston-Texans-logo.png';

import ravens_img from './img/One4One.png';
import gold_img from './img/gold_img.png';

import amazonaeb from './img/amazonaeb.png';
import ronaldo_img from './img/ronaldo_img.png';

import amazonlogo from './img/amazon-colection.png';
import gaialogo from './img/gaia-collection.png';

import partner1 from './img/partner1.png';
import partner2 from './img/partner2.png';
import partner3 from './img/partner3.png';
import partner4 from './img/partner4.png';
import partner5 from './img/partner5.png';
import partner6 from './img/partner6.png';

import RequestDefaultsHelper from '../../../helpers/RequestDefaultsHelper';
import { isFuture } from '../../../helpers/isFuture';
import { setInterval } from 'core-js';

const Footer = React.lazy(() => import('./Footer/footer'));
const Header = React.lazy(() => import('../Design/Components/PlatFormHeader'));
// const Carousel = React.lazy(() => import("../Design/Components/carousel"));
// const FeaturedCarousel = React.lazy(() =>
//   import("../Design/Components/featuredeventscarousel")
// );
// const InstaEmbed = React.lazy(() => import("../Design/Components/instaposts"));
// const Footer = React.lazy(() => import("../Design/Components/Footer"));

@inject('AuthStore')
@inject('UserStore')
@inject('StripeStore')
@inject('CompanyStore')
@inject('EventStore')
@inject('MarketPlace')
@inject('AthletesStore')
@observer
class Login extends Component {
  state = {
    loading: false,
    loading1: false,
    modaldata: false,
    isModalVisible: false,
    flag: '',
    head_title: '',
    data: {},
    press_and_fans: false,
    careers: false,
    videoPlay: false,
    videoMute: true,
    dark: 'black',
    featured_index: 4,
    start_featured: 0,
    athlete_index: 4,
    start_athlete: 0,
    five_minutes_in_sec: 300 * 1000,
    disable_submit_button: false,
    c_name: '',
    c_email: '',
    response_captcha: '',
    count: 0,
    acount: 0,
    poster: true,
    companydetail: {},
  };

  async componentDidMount() {
    this.props.AuthStore.setCompanyUrlName(
      this.props?.match?.params?.company_name ? this.props.match.params.company_name : 'igi',
    );

    CompanyPropsHelper('igi').then(async (data) => {
      RequestDefaultsHelper(
        data.url,
        data.api_key,
        this.props.match.params.company || this.props?.match?.params?.company_name,
        data.company_data,
      );
      this.setState({ companydetail: data.company_data });
    });

    RequestDefaultsHelper();
    this.setState({ loading: true });
    this.props.EventStore.getMainWebAppData();
    this.countDownInterval = setInterval(async () => {
      this.props.EventStore.getLatestPurchaseditems();
    }, this.state.five_minutes_in_sec);
    this.props.EventStore.getLatestPurchaseditems();
    //  this.props.EventStore.getCarouselEventItems();
    this.props.CompanyStore.get_companies_featured();
    this.props.EventStore.getSingleEventItems();
    this.props.EventStore.getFeaturedEvents();
    this.props.AthletesStore.getAthletes();
    this.props.EventStore.getUpcomingEvents();
    // AOS.init();
    // var video = document.getElementById('videoplay');
    // video.play();
    this.setState({ loading: false });
  }

  componentWillUnmount() {
    clearInterval(this.countDownInterval);
  }

  Next_Featured = () => {
    this.setState({ featured_index: this.state.featured_index + 4 });
    this.setState({ start_featured: this.state.start_featured + 4 });
    this.setState({ count: this.state.count + 1 });
  };

  Prev_Featured = () => {
    this.setState({ featured_index: this.state.featured_index - 4 });
    this.setState({ start_featured: this.state.start_featured - 4 });
    this.setState({ count: this.state.count - 1 });
  };

  Next_Athlete = () => {
    this.setState({ athlete_index: this.state.athlete_index + 4 });
    this.setState({ start_athlete: this.state.start_athlete + 4 });
    this.setState({ acount: this.state.acount + 1 });
  };

  Prev_Athlete = () => {
    this.setState({ athlete_index: this.state.athlete_index - 4 });
    this.setState({ start_athlete: this.state.start_athlete - 4 });
    this.setState({ acount: this.state.acount - 1 });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: this.state.c_name,
      email: this.state.c_email,
    };
    this.setState({ loading: true });
    await this.props.AuthStore.CareerApplications(data);
    this.setState({ loading: false });
    let submission_error = this.props.AuthStore.error;
    if (this.props.AuthStore.error != '') {
      notification.error({
        message: 'Error',
        description: `${submission_error}`,
        placement: 'bottomRight',
      });
      return;
    }
    notification.success({
      message: 'Success',
      description: 'Thanks for your interest, We will contact you shortly.',
      placement: 'bottomRight',
    });
    this.setState({ isModalVisible: false });
    this.setState({ c_name: '', c_email: '' });
    this.captcha.reset();
    return;
  };

  addDefaultSrc = (ev) => {
    ev.target.src = f2;
  };

  SetEventName = (value) => {
    this.props.CompanyStore.EventName = value;
  };
  setUrl = (url) => {
    localStorage.setItem('url', url);
  };

  showModal = async (value) => {
    if (value == 'AboutUs') {
      this.setState({ head_title: 'About Us' });
      this.setState({ data: this.props.EventStore?.mainwebappdata?.about_us });
    }
    if (value == 'WhyIGotIt') {
      this.setState({ head_title: 'Why I Got It' });
      this.setState({ data: this.props.EventStore?.mainwebappdata?.why_i_got_it });
    }
    if (value == 'FAQ') {
      this.setState({ head_title: 'Frequently Asked Questions' });
      this.setState({ data: this.props.EventStore?.mainwebappdata?.faq });
    }
    if (value == 'P&F') {
      this.setState({ head_title: 'Press & Fans', press_and_fans: true });
    }
    if (value == 'Careers') {
      this.setState({ head_title: 'Careers', careers: true });
    }
    this.setState({ isModalVisible: true });
    // let x = document.getElementsByClassName("ant-modal-header");
    // if (x.length > 0) {
    //   x[0].style.backgroundColor = "black";
    //   x[0].style.border = "1px solid white";
    // }
  };

  onChangeReCaptcha = (response) => {
    if (response.length !== 0) {
      this.setState({
        disable_submit_button: true,
      });
    }
  };

  onChangeInputData = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false, press_and_fans: false, careers: false });
  };
  handleCancel = () => {
    this.setState({ isModalVisible: false, press_and_fans: false, careers: false });
  };

  onChangeInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: value,
      },
    }));
  };

  VideoPlay = (videoId) => {
    this.setState({ poster: false });
    var video = document.getElementById(videoId);
    video.play();
  };
  VideoPause = (videoId) => {
    this.setState({ poster: true });
    var video = document.getElementById(videoId);
    video.load();
  };
  VideoMute_button = () => {
    var video = document.getElementById('videoplay');
    if (this.state.videoMute) {
      video.muted = true;
      this.setState({ videoMute: false });
      return;
    }
    video.muted = false;
    this.setState({ videoMute: true });
  };

  render() {

    SetThemeColor(this.state.companydetail?.company?.theme_color)

    // if (this.state.companydetail?.company?.theme_color === "black"){
    //    for (var i = 0; i < document.getElementsByClassName('rootbg').length; i++) {
    //       document.getElementsByClassName('rootbg')[i].style.backgroundColor = `${this.state.companydetail?.company?.theme_color}`;
    //     }
    //        var headingsAndParagraphs = document.querySelectorAll('h1, h2, h3, h4, h5, p, a');
    //        for (var i = 0; i < headingsAndParagraphs.length; i++) {
    //          var currentElement = headingsAndParagraphs[i];
    //          currentElement.style.color = '#fff';
    //        }

    //      for (var i = 0; i < document.getElementsByClassName('reversebg').length; i++) {
    //       document.getElementsByClassName('reversebg')[i].style.backgroundColor = '#2C2C2C';

    //     }
    //       var headings = document.querySelectorAll('h1, h2, h3, h4, h5, p, a');
    //       for (var i = 0; i < headings.length; i++) {
    //          var currentElement = headings[i];
    //          currentElement.style.color = '#fff';
    //        }
    // }
    // else{
    //   for (var i = 0; i < document.getElementsByClassName('rootbg').length; i++) {
    //       document.getElementsByClassName('rootbg')[i].style.backgroundColor = `${this.state.companydetail?.company?.theme_color}`;
    //     }
    //     var headingsAndParagraphs = document.querySelectorAll('h1, h2, h3, h4, h5, p, a');
    //     for (var i = 0; i < headingsAndParagraphs.length; i++) {
    //       var currentElement = headingsAndParagraphs[i];
    //       currentElement.style.color = '#252525';
    //     }
    //     for (var i = 0; i < document.getElementsByClassName('reversebg').length; i++) {
    //       document.getElementsByClassName('reversebg')[i].style.backgroundColor = '#E7E0EC';
    //     }
    //     var headings = document.querySelectorAll('h1, h2, h3, h4, h5, p, a');
    //     for (var i = 0; i < headings.length; i++) {
    //       var currentElement = headings[i];
    //       currentElement.style.color = '#252525';
    //     }
    // }
    const data = this.props.EventStore?.mainwebappdata;
    const videoUrl = data?.featured_video?.featured_video?.url;

    const index = Math.ceil(this.props.EventStore?.featuredevents?.length / 4);
    const index_athlete = Math.ceil(this.props.AthletesStore?.athletes?.length / 4);

    return (
      <Spin spinning={this.state.loading}>
        {/* <div className="row no-gutter shadow-lg reversebg">
          <marquee width="100%" direction="left" height="100%" behaviour="scrolling" scrollamount="15">
            <div className="row" style={{ overflowX: 'visible' }}>
              <div className="col" style={{ display: 'flex' }}>
                {this.props.EventStore?.latest_purchased_items?.map((lpi) => (
                  <div className="py-3 px-5" style={{ fontSize: '14px', marginRight: '8%' }}>
                    <i className="fa far fa-circle" style={{ fontSize: '13px' }}></i>
                    <span style={{ fontWeight: 'bold' }}>{lpi.title}</span> purchased for{' '}
                    <span style={{ fontWeight: 'bold' }}>${lpi.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </marquee>
        </div> */}
        <Header discord_link={data?.discord_link ?? ''} main_home={true} />
        {/* <section>
          {
            <a href="http://www.wefunder.com/igotit" target="_blank" >
              <div
                className="main-banner text-left d-flex"
                style={{
                  backgroundImage: `url(${webbanner})`,
                  height: "100%",
                  paddingLeft: "13px",
                }}
              >

                <div className="text-white text-center p-5 ">

                </div>
              </div>
            </a>
          }
        </section> */}
        {/* <section>
          <div className="text-white text-center p-5 ">
            <h3 className={this.props.AuthStore.dark_model_toggle ? 'mobile-font' : 'darkmode mobile-font'}>
              {data?.top_banner_title}
            </h3>
            <h3 className={this.props.AuthStore.dark_model_toggle ? 'mobile-font' : 'darkmode mobile-font'}>
              {data?.top_banner_sub_title}
            </h3>
          </div>
        </section> */}
        {this.props.EventStore.featuredevents?.length != 0 && (
          <section>
            <div id="demo" className="carousel slide mobile-font rootbg" data-ride="carousel">
              {/* <ul className="carousel-indicators">
                {this.props.EventStore.featuredevents.map((index) => (
                  <li data-target="#demo" data-slide-to="0" className={index == 0 ? 'active' : ''}></li>
                ))}
              </ul> */}
              <div className="carousel-inner  " id="upcomingdrops">
                {this.props.EventStore?.mainwebappdata?.main_app_features?.map((fe, index) => (
                  <div
                    className={index == 0 ? 'carousel-item active' : 'carousel-item'}
                    style={{ textAlign: 'center' }}
                  >
                    <img
                      className="carousel-img"
                      src={fe?.top_banner_image?.url}
                      alt="Los Angeles"
                      width="90%"
                      height="394"
                      style={{ width: '90%!important' }}
                    />
                    {isFuture(fe.start_at) ? (
                      <div className="text-center p-5 " style={{ marginTop: '-180px', height: '180px' }}>
                        <div className="" style={{ marginTop: '50px' }}>
                          <h3 className="mobile-font ">{fe.title}</h3>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center p-5" style={{ marginTop: '-180px', height: '180px' }}>
                        <div className="">
                          <h3 className="mobile-font text-white">{fe.title}</h3>
                          {/* <h3 className="text-white mobile-font">{fe.tag_line}</h3> */}
                        </div>
                        <div className="mt-4">
                          <a className="text-decoration-none" href={`${fe.view_more}`}>
                            <h3 style={{ fontSize: '20px', letterSpacing: '0.2px' }}>
                              <u className="slide-text text-decoration-none text-white">Learn More</u>
                            </h3>
                          </a>
                        </div>
                        <div className="">
                          <a href={`${fe.discord_link}`}>
                            <button className="notify-me mt-5 mb-5 blkthemebtn text-dark">Buy</button>
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <a className="carousel-control-prev" href="#demo" data-slide="prev">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-prev-icon"></span>
                </div>
              </a>
              <a className="carousel-control-next" href="#demo" data-slide="next">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-next-icon"></span>
                </div>
              </a>
            </div>
          </section>
        )}

        <section>
          <div className="container">
            <div className="py-5 my-5">
              <div className="text-center zig-zag-mob">
                <div className="row">
                  <div className="col-md-4 col-sm-12" data-aos="fade-right" data-aos-duration="2000" style={{}}>
                  <a >
                    <video
                      loop
                      onMouseOut={() => this.VideoPause('videoplay')}
                      onMouseOver={() => this.VideoPlay('videoplay')}
                      className="video_main_page"
                      type="video/mp4"
                      id="videoplay"
                      poster={chase}
                      style={{ cursor: 'pointer', boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px', width: '100%' }}
                    >
                      {/* <source
                        src={'https://igotit-production.s3.amazonaws.com/assets/ronaldo.mp4'}
                        type="video/mp4"
                      ></source> */}
                    </video>
                    </a>
                  </div>
                  <div className="col-md-8 col-sm-12">
                    <div className="d-flex align-items-center" style={{ height: '100%' }}>
                      <div className="text-start responsive-text">
                        <h3 data-aos="fade-left" data-aos-duration="2000">
                          Physical Memorabilia Items
                        </h3>
                        <div>
                          <div className="hwrap">
                            <div className="hmove">
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div>Items are sourced from a team, player or player representative</div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div>
                                    Provenance and authentication are recorded on Metabilia's private blockchain
                                  </div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div>Items are sourced from a team, player or player representative</div>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-5 mt-3">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row text-end column-reverse pt-5">
                  <div className="col-md-8 col-sm-12">
                    <div className="d-flex align-items-center" style={{ height: '100%' }}>
                      <div className="text-end responsive-text">
                        <h3 data-aos="fade-right" data-aos-duration="2000">
                          One4One Auction Items
                        </h3>
                        <div>
                          <div className="hwrap">
                            <div className="hmove">
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-right"
                                  data-aos-duration="3000"
                                >
                                  <div>Get unique game-used and autographed memorabilia</div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-right"
                                  data-aos-duration="3000"
                                >
                                  <div>Take delivery of your physical collectible at any time</div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-right"
                                  data-aos-duration="3000"
                                >
                                  <div>Sell your collectible on our marketplace</div>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-5 mt-3">
                            <a className="text-decoration-none" href={'/one4one/igi'}>
                              <h3
                                style={{ fontSize: '20px', letterSpacing: '0.2px' }}
                                data-aos="fade-right"
                                data-aos-duration="3000"
                              >
                                <u className="slide-text text-decoration-none">Learn More</u>
                              </h3>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12" data-aos="fade-left" data-aos-duration="2000">
                  <a href={'/one4one/igi'}>
                    <video
                      loop
                      onMouseOut={() => this.VideoPause('videoplay2')}
                      onMouseOver={() => this.VideoPlay('videoplay2')}
                      className="video_main_page"
                      type="video/mp4"
                      id="videoplay2"
                      poster={one4onemetabiliagraphic}
                      style={{ cursor: 'pointer', boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px', width: '100%' }}
                    >
                      {/* <source
                        src={'https://igotit-production.s3.amazonaws.com/assets/one4one.mp4'}
                        type="video/mp4"
                      ></source> */}
                    </video>
                    </a>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-4 col-sm-12" data-aos="fade-right" data-aos-duration="2000">
                  <a href={'/gaia_missions/igi'}>
                    <video
                      loop
                      onMouseOut={() => this.VideoPause('videoplay3')}
                      onMouseOver={() => this.VideoPlay('videoplay3')}
                      className="video_main_page"
                      type="video/mp4"
                      id="videoplay3"
                      // poster={silverlandry}
                      poster={MemberNFT}
                      style={{
                        cursor: 'pointer',
                        boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px',
                        width: '100%'

                      }}
                    >
                      <source
                        src={'https://igotit-production.s3.amazonaws.com/assets/GAIA_META_VIDEO_MR_NEW.mp4'}
                        type="video/mp4"
                      ></source>
                    </video>
                    </a>
                  </div>
                  <div className="col-md-8 col-sm-12">
                    <div className="d-flex align-items-center" style={{ height: '100%' }}>
                      <div className="text-start responsive-text">
                        <h3 data-aos="fade-left" data-aos-duration="2000">
                          Athlete Digital Collectibles
                        </h3>
                        <div>
                          <div className="hwrap">
                            <div className="hmove">
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div>Holders get airdropped collectibles commemorating great events</div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div>Buy and trade them on Metabilia or DraftKings Marketplace</div>
                                </p>
                              </div>
                              <div class="hslide">
                                <p
                                  className=""
                                  style={{ fontSize: '20px', color: '#fff' }}
                                  data-aos="fade-left"
                                  data-aos-duration="3000"
                                >
                                  <div className="text-white">
                                    Holders get airdropped collectibles commemorating great events
                                  </div>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-5 mt-3">
                            <a className="text-decoration-none" href={'/gaia_missions/igi'}>
                              <h3
                                style={{ fontSize: '20px', letterSpacing: '0.2px' }}
                                data-aos="fade-left"
                                data-aos-duration="2000"
                              >
                                <u className="slide-text text-decoration-none">Learn More</u>
                              </h3>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container py-5 my-5 ">
            <div className="text-center py-5">
              <h1>FEATURED COLLECTIONS</h1>
            </div>
            <div
              id="multi-item-example"
              className="container carousel slide carousel-multi-item position-relative"
              data-ride="carousel"
            >
              {/* <!--Controls--> */}

              <div className="controls-top">
                {this.state.start_featured != 0 ? (
                  <a
                    className="btn-floating control-prev reversebg"
                    href="#multi-item-example"
                    data-slide="prev"
                    onClick={this.Prev_Featured}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </a>
                ) : (
                  <a className="btn-floating control-prev reversebg" href="#multi-item-example" data-slide="prev">
                    <i className="fa fa-chevron-left"></i>
                  </a>
                )}

                {this.state.count != index - 1 ? (
                  <a
                    className="btn-floating control-next reversebg"
                    href="#multi-item-example"
                    data-slide="next"
                    onClick={this.Next_Featured}
                  >
                    <i className="fa fa-chevron-right"></i>
                  </a>
                ) : (
                  <a className="btn-floating control-next reversebg" href="#multi-item-example" data-slide="next">
                    <i className="fa fa-chevron-right"></i>
                  </a>
                )}
              </div>

              <div className="carousel-inner" role="listbox">
                {/* <!--First slide--> */}

                <div className="carousel-item active">
                  <div className="row">
                    {this.props.EventStore?.featuredevents
                      ?.slice(this.state.start_featured, this.state.featured_index)
                      ?.map((cf, i) => (
                        <div className="col-md-3">
                          <div className="mb-2">
                            <a href={`/platforms/igi/events/${cf.id}`}>
                              <div className="shadow reversebg">
                                {cf.featured_photo.featured_photo.url == null ? (
                                  <img
                                    lazy={true}
                                    className="card-img-top"
                                    src={img10}
                                    alt="Avatar"
                                    style={{ width: '100%', height: '240px', minHeight: '240px', objectFit: 'cover' }}
                                  />
                                ) : (
                                  <img
                                    className="card-img-top"
                                    src={cf.featured_photo.featured_photo.url}
                                    alt="Avatar"
                                    style={{ width: '100%', height: '240px', minHeight: '240px', objectFit: 'cover' }}
                                  />
                                )}

                                <div
                                  className="text-center d-flex justify-content-center align-items-center"
                                  style={{ height: '65px', minHeight: '65px' }}
                                >
                                  <h6
                                    className="slide-text p-5 m-0"
                                    style={{
                                      color:
                                        this.state.companydetail?.company?.theme_color == 'black' ? 'white' : 'black',
                                    }}
                                  >
                                    {cf.title}
                                  </h6>
                                </div>
                                <div class="img-overlay">
                                  <button>Browse &amp; Bid</button>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* <!--/.Third slide--> */}
              </div>

              {/* <!--/.Slides--> */}
            </div>
          </div>
        </section>

        {this.props.EventStore?.mainwebappdata?.highlight_features ? (
          <section>
            <div id="demo1" className="carousel slide mobile-font rootbg" data-ride="carousel">
              <div className="carousel-inner  " id="upcomingdrops">
                {/* {this.props.EventStore?.mainwebappdata.highlight_features?.map((d, index) => ( */}
                  <div
                    className={index == 0 ? 'carousel-item active' : 'carousel-item'}
                    style={{ textAlign: 'center' }}
                  >
                    <a href={`${this.props.EventStore?.mainwebappdata?.highlight_url}`}>
                      <img
                        className="carousel-img secondslider"
                        src={this.props.EventStore?.mainwebappdata?.highlight_image.highlight_image.url}
                        alt="Los Angeles"
                        width="100%"
                        height="auto"
                      />
                    </a>
                  </div>
                {/* ))} */}
              </div>
              <a className="carousel-control-prev" href="#demo1" data-slide="prev">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-prev-icon"></span>
                </div>
              </a>
              <a className="carousel-control-next" href="#demo1" data-slide="next">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-next-icon"></span>
                </div>
              </a>
            </div>
          </section>
        ) : null}

        {/* {this.props.EventStore?.mainwebappdata.highlight_features ? (

        <section>
            <div className="text-center py-5">
              <h1 className="text-white">HIGHLIGHTS</h1>
            </div>
          <div id="test" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner"  id="highlighfeatures">
               {this.props.EventStore?.mainwebappdata.highlight_features?.map((d,index) => (
              <a href={`${d?.highlight_url}`}>
              <div className={index == 0 ? "carousel-item active": "carousel-item"}>
                <img src={d?.highlight_image.highlight_image.url} className="d-block w-100 carousel-img"  alt="..." />
              </div>
              </a>
                ))}

            </div>
           <a className="carousel-control-prev" href="#test" data-slide="prev">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-prev-icon"></span>
                </div>
              </a>
              <a className="carousel-control-next" href="#test" data-slide="next">
                <div className="carousel-control-bg">
                  {' '}
                  <span className="carousel-control-next-icon"></span>
                </div>
              </a>
          </div>
        </section>

 ): null}  */}

        <section>
          <div className="container py-5 my-5">
            <div className="text-center py-5">
              <h1>ATHLETE GAME USED MEMORABILIA PARTNERS</h1>
            </div>
            <div
              id="multi-item-example-new"
              className="container carousel slide carousel-multi-item position-relative"
              data-ride="carousel"
            >
              {/* <!--Controls--> */}
              <div className="controls-top">
                {this.state.start_athlete != 0 ? (
                  <a
                    className="btn-floating control-prev reversebg"
                    href="#multi-item-example"
                    data-slide="prev"
                    onClick={this.Prev_Athlete}
                  >
                    <i className="fa fa-chevron-left"></i>
                  </a>
                ) : (
                  <a className="btn-floating control-prev reversebg" href="#multi-item-example" data-slide="prev">
                    <i className="fa fa-chevron-left"></i>
                  </a>
                )}

                {this.state.acount != index_athlete - 1 ? (
                  <a
                    className="btn-floating control-next reversebg"
                    href="#multi-item-example"
                    data-slide="next"
                    onClick={this.Next_Athlete}
                  >
                    <i className="fa fa-chevron-right"></i>
                  </a>
                ) : (
                  <a className="btn-floating control-next reversebg" href="#multi-item-example" data-slide="next">
                    <i className="fa fa-chevron-right"></i>
                  </a>
                )}
              </div>
              {/* {!--/.Controls--} */}

              {/* <!--Indicators--> */}
              {/* <ol className="carousel-indicators">
                <li data-target="#multi-item-example-new" data-slide-to="0" className="active"></li>
                <li data-target="#multi-item-example-new" data-slide-to="1"></li>
                <li data-target="#multi-item-example-new" data-slide-to="2"></li>
              </ol> */}
              {/* <!--/.Indicators--> */}

              {/* <!--Slides--> */}
              <div className="carousel-inner athlete-partner" role="listbox">
                {/* <!--First slide--> */}
                <div className="carousel-item active">
                  <div className="row">
                    {this.props.AthletesStore?.athletes
                      ?.slice(this.state.start_athlete, this.state.athlete_index)
                      ?.map((d, i) => (
                        <div className="col-md-3">
                          <div className="mb-2">
                            <a href={d.link} target="_blank" className="pointer">
                              <div className="shadow reversebg">
                                {d.badge.badge.url == null ? (
                                  <img
                                    src={athlete1}
                                    alt="Avatar"
                                    style={{ width: '100%', height: '240px', minHeight: '240px', objectFit: 'cover' }}
                                  />
                                ) : (
                                  <img
                                    src={d.badge?.badge?.url}
                                    alt="Avatar"
                                    style={{ width: '100%', height: '240px', minHeight: '240px', objectFit: 'cover' }}
                                  />
                                )}
                                <div className="text-center">
                                  <h6 className="slide-text p-5">{d.name}</h6>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* <!--/.Third slide--> */}
              </div>
              {/* <!--/.Slides--> */}
            </div>
          </div>
        </section>
        {/* <section>
          <div className="container pt-5 mt-5">
            <div className="text-center py-5">
              <h1 className="text-white">I GOT IT PLATFORM</h1>
            </div>
            <div className="row d-flex flex-wrap justify-content-center gt-2 pt-5">
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-up" data-aos-duration="2000">
                  <div>
                    <img src={gotit1} alt="Avatar" style={{ width: '100%' }} />
                  </div>
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Anthony Richardson</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-down" data-aos-duration="2000">
                  <img src={gotit2} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Tyreek Hill</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-up" data-aos-duration="2000">
                  <img src={gotit3} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Derek Stingley Jr.</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-down" data-aos-duration="2000">
                  <img src={gotit4} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Derek Stingley Jr.</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-up" data-aos-duration="2000">
                  <img src={gotit5} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Derek Stingley Jr.</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-down" data-aos-duration="2000">
                  <img src={gotit6} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Derek Stingley Jr.</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="shadow" data-aos="flip-up" data-aos-duration="2000">
                  <img src={gotit7} alt="Avatar" style={{ width: '100%' }} />
                  <div className="text-center" style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}>
                    <h6 className="text-white p-5">Derek Stingley Jr.</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section>
          {/* <div className="container py-5 my-5">
            <div className="text-center py-5">
              <h1>PARTNER MEMORABILIA MARKETPLACES</h1>
            </div>
            <div data-ride="carousel">
              <div className="container" role="listbox">
                <div className="">
                  <div className="row align-items-center justify-content-center" style={{ gap: '45px' }}>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/bengals`}>
                        <img src={Bengals} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/chiefs`}>
                        <img src={Chiefs} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/chargers`}>
                        <img src={Chargers} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/jaguars`}>
                        <img src={Jags} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                  </div>
                  <div className="row align-items-center pt-5 justify-content-center" style={{ gap: '45px' }}>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/ravens`}>
                        <img src={Ravens} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/texans`}>
                        <img src={HoustonTexans} alt="Avatar" style={{ width: '210px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/bucks`}>
                        <img src={Buckslogo} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>

                    <div className="col-md-2 text-center">
                      <a href={`${process.env.REACT_APP_WEB_BASE_URL}/platforms/kings`}>
                        <img src={Kings} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="container py-5 my-5">
            <div className="text-center py-5">
              <h1>OTHER COLLABORATIONS</h1>
            </div>
            <div data-ride="carousel">
              {/* <!--Slides--> */}
              <div className="container" role="listbox">
                {/* <!--First slide--> */}
                <div className="">
                  <div className="row align-items-center pt-5 justify-content-center" style={{ gap: '45px' }}>
                    <div className="col-auto text-center">
                      <a href={'javascript:void(0)'}>
                        <img src={amazonlogo} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>

                    <div className="col-auto text-center">
                      <a href={'javascript:void(0)'}>
                        <img src={Pistons} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>

                    <div className="col-auto text-center">
                      <a href="javascript:void(0)">
                        <img src={PFHOF} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-auto text-center">
                      <a href="javascript:void(0)">
                        <img src={DraftKings} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-auto text-center">
                      <a href={'javascript:void(0)'}>
                        <img src={MLBPlayers} alt="Avatar" style={{ width: '140px', height: 'auto' }} />
                      </a>
                    </div>
                    <div className="col-auto text-center">
                      <a href={'javascript:void(0)'}>
                        <img src={gaialogo} alt="Avatar" style={{ width: '140px', height: 'auto' }} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container-fluid">
            <div className="row justify-content-center g-0">
              <div className="container py-5 my-5">
                <div className="text-center py-5">
                  <h1> METABILIA PLATFORM</h1>
                </div>
                <div className="row responsive-cards mb-5 justify-content-center g-0">
                  <div className="col-md-3 single-image" data-aos="flip-up" data-aos-duration="3000">
                    <div className="flip-card">
                      <div className="flip-card-inner reversebg">
                        <div className="flip-card-front">
                          <img src={gotit1} alt="Avatar" />
                          <h5 className="flip-card-front-text">Ownership Assured</h5>
                        </div>
                        <div className="flip-card-back">
                          <img lazy={true} src={overlay} alt="" />
                          <p className="overlay-text text-white">
                            Digital assets sold on the Metabilia platform are minted on our private blockchain powered
                            by Amazon's Quantum Ledger. Transactions are cryptographically protected ensuring
                            immutability of records, transparency of ownership, and accurate provenance.
                          </p>
                          <h5 className="flip-card-front-text">Ownership Assured</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*
                  <div className="col-md-3 single-image" data-aos="flip-up" data-aos-duration="3000">
                    <div className="flip-card">
                      <div className="flip-card-inner reversebg">
                        <div className="flip-card-front">
                          <img src={gotit2} alt="Avatar" />
                          <h5 className="flip-card-front-text">Maximum Mint Guarantee</h5>
                        </div>
                        <div className="flip-card-back">
                          <img src={overlay} alt="" />
                          <p className="overlay-text text-white">
                            Metabilia will always let you know how many assets are minted of each collection and impose
                            lifetime issuance limits for each athlete.
                          </p>
                          <h5 className="flip-card-front-text">Maximum Mint Guarantee</h5>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-3 single-image" data-aos="flip-up" data-aos-duration="3000">
                    <div className="flip-card">
                      <div className="flip-card-inner reversebg">
                        <div className="flip-card-front">
                          <img src={gotit3} alt="Avatar" />
                          <h5 className="flip-card-front-text">Multi-platform Trading</h5>
                        </div>
                        <div className="flip-card-back">
                          <img src={overlay} alt="" />
                          <p className="overlay-text text-white">
                            Metabillia sells it physical collectibles on its NFL and NBA team partner Apps and
                            Metabilia.io. We also sell digital collectibles on DraftKings Marketplace, Gaia and Amazon
                            (to be launched).
                          </p>
                          <h5 className="flip-card-front-text">Multi-platform Trading</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 single-image" data-aos="flip-up" data-aos-duration="3000">
                    <div className="flip-card">
                      <div className="flip-card-inner reversebg">
                        <div className="flip-card-front">
                          <img src={gotit4} alt="Avatar" />
                          <h5 className="flip-card-front-text">Simple Payment Execution</h5>
                        </div>
                        <div className="flip-card-back">
                          <img src={overlay} alt="" />
                          <p className="overlay-text text-white" style={{ marginTop: '-6%' }}>
                            On Metabilia.io, Payments can be made with all major credit cards. Integrations with PayPal
                            and Stripe ensure funds will be readily available for disbursement after sales on the
                            Metabilia Marketplace.
                          </p>
                          <h5 className="flip-card-front-text">Simple Payment Execution</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section>
          <div className="container-fluid pt-5 mt-5">
            <div className="text-center py-5">
              <h1 className="text-white">PROUD PARTNERS</h1>
            </div>
            <div
              id="proud-partners"
              className="container-fluid carousel slide carousel-multi-item position-relative"
              data-ride="carousel"
            >

              <div className="carousel-inner" role="listbox">
                <div className="carousel-item proud-partner active">
                  <div className="row">
                    <div className="col-md-2">
                      <a href={`./platforms/bucks`} >
                        <div className="mb-2">
                          <div className="shadow athelte-pip-img">
                            <img
                              src={Buckslogo}
                              alt="Avatar"
                              style={{ width: '250px', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Bucks Bids</h6>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <a href={`./platforms/kings`} >
                          <div className="shadow athelte-pip-img">
                            <img
                              src={Kings}
                              alt="Avatar"
                              style={{ width: '250px', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Kings Auctions</h6>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <a href={`./platforms/chiefs`} >
                          <div className="shadow athelte-pip-img">
                            <img
                              src={Chiefs}
                              alt="Avatar"
                              style={{ width: '250px', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Kansas City Bids</h6>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <a href={`/platforms/saints`} >
                          <div className="shadow athelte-pip-img">
                            <img
                              src={proud4}
                              alt="Avatar"
                              style={{ width: '100%', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Saints Auctions</h6>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <a href={`/platforms/chargers`} >
                          <div className="shadow athelte-pip-img">
                            <img
                              src={proud5}
                              alt="Avatar"
                              style={{ width: '100%', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Chargers</h6>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <a href={`/platforms/pistons`} >
                          <div className="shadow athelte-pip-img">
                            <img
                              src={proud6}
                              alt="Avatar"
                              style={{ width: '100%', height: 'auto', objectFit: 'none' }}
                            />
                            <div
                              className="text-center"
                              style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                            >
                              <h6 className="text-white p-5">Pistons</h6>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item proud-partner">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud1} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px', height: '75px' }}
                          >
                            <h6 className="text-white p-5">Bucks Bids</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud2} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Kings Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud3} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Kansas City Bids</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud4} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud5} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud6} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item proud-partner">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud1} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Bucks Bids</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud2} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Kings Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud3} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Kansas City Bids</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud4} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud5} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div className="shadow athelte-pip-img">
                          <img src={proud6} alt="Avatar" style={{ width: '100%', height: 'auto', objectFit: 'none' }} />
                          <div
                            className="text-center"
                            style={{ backgroundColor: '#2C2C2C', borderRadius: '0 0 10px 10px' }}
                          >
                            <h6 className="text-white p-5">Saints Auctions</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>*/}

        <section>
          <div className="container-fluid py-5 my-5">
            <div className="text-center py-5">
              <h1>TECHNOLOGY INTEGRATIONS</h1>
            </div>
            <div
            // id="proud-partners"
            // className="container-fluid carousel slide carousel-multi-item position-relative"
            // data-ride="carousel"
            >
              {/* <!--Slides--> */}
              <div className="" role="">
                {/* <!--First slide--> */}
                <div className="container">
                  <div className="d-flex justify-content-center align-items-center gx-5 flex-wrap gap-tech">
                    {/* <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner1} alt="Avatar" style={{ width: '100px', height: 'auto' }} />
                        </div>
                      </div>
                    </div> */}

                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner2} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner3} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner4} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner5} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={partner6} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img
                            src={amazonaeb}
                            alt="Avatar"
                            style={{ width: '150px', height: 'auto', filter: 'brightness(0.5)' }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-2">
                        <div>
                          <img src={pusherlogo} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="carousel-item">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <div className="mb-2">
                        <div>
                          <img src={partner1} alt="Avatar" style={{ width: '100px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner2} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner3} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner4} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner5} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner6} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <div className="mb-2">
                        <div>
                          <img src={partner1} alt="Avatar" style={{ width: '100px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner2} alt="Avatar" style={{ width: '130px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner3} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner4} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner5} alt="Avatar" style={{ width: '190px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 clearfix d-none d-md-block">
                      <div className="mb-2">
                        <div>
                          <img src={partner6} alt="Avatar" style={{ width: '150px', height: 'auto' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <!--/.Third slide--> */}
              </div>
              {/* <!--/.Slides--> */}
            </div>
          </div>
        </section>

        {/* <div className="col-md-4 text-white text-center">
                <div className="d-flex justify-content-center">
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      border: '2px solid #fff',
                      borderRadius: '100%',
                      width: '120px',
                      height: '120px',
                    }}
                  >
                    <img src={iconrugby} alt="Avatar" style={{ width: '40px' }} />
                  </div>
                </div>
                <div className="pt-5 pb-5">
                  <h3 className="text-white">Buy and Sell Legendary Sports NFTs</h3>
                </div>
              </div>
              <div className="col-md-4 text-white ">
                <div className="d-flex justify-content-center">
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      border: '2px solid #fff',
                      borderRadius: '100%',
                      width: '120px',
                      height: '120px',
                    }}
                  >
                    <img src={Frame} alt="Avatar" style={{ width: '40px' }} />
                  </div>
                </div>
                <div className="pt-5 text-center">
                  <h5 className="text-white">Meet the athlete</h5>
                  <p></p>
                </div>
              </div> */}

        {/* {videoUrl ? (
          <section>
            <div className="container text-center" style={{ color: '#375073', padding: '2%' }}>
              <h3
                className={
                  !this.props.AuthStore.dark_model_toggle
                    ? 'backend_text_dark video_left_text'
                    : 'backend_text_normal video_left_text'
                }
                style={{ fontWeight: '700', paddingBottom: '1%' }}
                dangerouslySetInnerHTML={{ __html: data?.top_text }}
              ></h3>
            </div>
            <div className="container text-center" style={{ color: '#375073', padding: '2%' }}>
              <div className="row justify-content-center">
                <div className="col-md-6 col-sm-12 text-left">
                  <p
                    className={
                      !this.props.AuthStore.dark_model_toggle
                        ? 'backend_text_dark video_left_text'
                        : 'backend_text_normal video_left_text'
                    }
                    dangerouslySetInnerHTML={{ __html: data?.top_description }}
                  ></p>
                </div>
                <div className="col-md-6">
                  <div className="col" style={{ position: 'relative' }}>
                    <div onClick={() => this.VideoMute_button()}>
                      <i
                        className={
                          this.state.videoMute == true
                            ? 'fa fal  fa-volume-up mute_button'
                            : 'fa fal fa-volume-mute mute_button'
                        }
                      ></i>
                    </div>
                    <div onClick={() => this.VideoPlay_button()}>
                      <i
                        className={this.state.videoPlay == false ? 'fa fab fa-play play_button' : ''}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <video
                      onClick={() => this.VideoPlay_button()}
                      loop
                      className="video_main_page"
                      src={videoUrl}
                      type="video/mp4"
                      id="videoplay"
                      style={{ cursor: 'pointer', boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section>
            <div className="container text-center" style={{ color: '#375073', padding: '4%' }}>
              <h3
                className={!this.props.AuthStore.dark_model_toggle ? 'backend_text_dark' : 'backend_text_normal'}
                style={{ fontWeight: '700', paddingBottom: '5%' }}
                dangerouslySetInnerHTML={{ __html: data?.top_text }}
              ></h3>
              <p
                className={!this.props.AuthStore.dark_model_toggle ? 'backend_text_dark' : 'backend_text_normal'}
                dangerouslySetInnerHTML={{ __html: data?.top_description }}
              ></p>
            </div>
          </section>
        )} */}

        {/* <section>
          <div className="container py-5">
            <h1
              className={
                this.props.AuthStore.dark_model_toggle ? 'text-center mobile-font' : 'darkmode text-center mobile-font'
              }
              style={{ padding: '3%' }}
            >
              ATHLETE PIPELINE
            </h1>
          </div>
          <div className="container pt-2">
            <div>
              <ul className="featured-teams-gallery list-unstyled">
                <div className="row" style={{ width: '100%' }}>
                  {this.props.AthletesStore.athletes.slice(0, this.state.athlete_index).map((d, i) => (
                    <>
                      <div className={i > 3 ? 'col-md-3 col-sm-6 col-6  mt-4' : 'col-md-3 col-sm-6 col-6 '}>
                        <a href={d.link} target="_blank">
                          <li>
                            {d.badge.badge.url == null ? (
                              <img
                                className="zoom"
                                style={{ boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px' }}
                                src={img9}
                                alt=""
                              />
                            ) : (
                              <img
                                className="zoom"
                                style={{ boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px' }}
                                src={d.badge?.badge?.url}
                                alt=""
                              />
                            )}
                          </li>
                        </a>
                      </div>
                    </>
                  ))}
                </div>
              </ul>
            </div>
            <div className="mt-5 py-5 text-center">
              {this.state.athlete_index < this.props.AthletesStore.athletes.length && (
                <button onClick={this.ViewMore_Athletes} className="img-view-more mobile-btn">
                  View More
                </button>
              )}
            </div>
          </div>
        </section> */}
        {/* <section>
          <div className="container py-5 mt-5">
            <h1
              className={
                this.props.AuthStore.dark_model_toggle ? 'text-center mobile-font' : 'darkmode text-center mobile-font'
              }
            >
              FEATURED MARKETPLACES
            </h1>
          </div>
          <div className="container pt-5">
            <div>
              <ul className="featured-teams-gallery list-unstyled mb-5">
                <div className="row">
                  {this.props.CompanyStore.companies_featured.slice(0, this.state.featured_index).map((cf, i) => (
                    <div className={i > 3 ? 'col-md-3 col-sm-6 col-6 mt-4' : 'col-md-3 col-sm-6 col-6'}>
                      <li className="featured-teams">
                        {cf.featured_marketplace_photo?.featured_marketplace_photo?.url == null ? (
                          <img style={{ boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px' }} src={img10} alt="" />
                        ) : (
                          <img
                            style={{ boxShadow: 'rgb(0 0 0 / 59%) 8px 7px 6px' }}
                            src={cf.featured_marketplace_photo?.featured_marketplace_photo?.url}
                            alt=""
                          />
                        )}
                        <div className="img-overlay">
                          {}
                          <>
                            <a href={`/platforms/${cf.subdomain}`} >
                              <button>Browse & Bid</button>
                            </a>
                            {/* <a href={cf.ios_app_url} target="_blank">
                              <button className="mt-2">Team App</button>
                            </a> */}
        {/* </>
                        </div>
                      </li>
                    </div>
                  ))}
                </div>
              </ul>
            </div>

            <div className="mb-5 py-5 mt-5 text-center">
              {this.state.featured_index < this.props.CompanyStore.companies_featured.length && (
                <button onClick={this.ViewMore_Featured} className="img-view-more">
                  View More
                </button>
              )}
            </div>
          </div>
        </section> */}
        {/* <section style={{ paddingBottom: '5%' }}>
          <div className="row justify-content-center">
            <h1
              className={
                this.props.AuthStore.dark_model_toggle ? 'text-center mobile-font' : 'darkmode text-center mobile-font'
              }
              style={{ padding: '2%' }}
            >
              I Got It Platform
            </h1>
            <div>
              <ul
                className="
                responsive-cards
        list-unstyled
        justify-content-center
        align-items-center
        pt-5
        mt-5
        gap-5
      "
              >
                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip1} alt="Avatar" />
                        <h5 className="flip-card-front-text">OWN YOUR HIGHLIGHT OF THE GAME</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          Our goal is to engage fans with sales of in-game memorabilia, unique experiences, and digital
                          collectibles/NFTs.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip2} alt="Avatar" />
                        <h5 className="flip-card-front-text">BEST PARTNERS IN SPORTS</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          We work with the best teams and organizations in the NFL and NBA, and we continue to expand
                          our partnerships. Check out Featured Marketplaces and start bidding today!
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip3} alt="Avatar" />
                        <h5 className="flip-card-front-text">ATHLETE CHARTER MEMBERSHIP NFTs</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          Take part in the upside of your favorite players. Owners of Charter Membership NFTs have
                          exclusive access to purchase Event NFTs derived from future great moments.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip4} alt="Avatar" />
                        <h5 className="flip-card-front-text">I GOT IT CRYPTOLEDGER</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text" style={{ marginTop: '-6%' }}>
                          All assets are minted on the I Got It Crypto Ledger, which is powered by AWS' Quantum Ledger
                          Product. Transactions are cryptographically protected ensuring immutability of records,
                          transparence of ownership, and accurate provenance.{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <ul
                className="
        list-unstyled
        responsive-cards
        justify-content-center
        align-items-center
        pt-5
        mt-5
        gap-5
      "
              >
                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip5} alt="Avatar" />
                        <h5 className="flip-card-front-text">MAXIMUM MINT GUARANTEE</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          I Got It will always let you know how many assets are minted of each type. Initially, we will
                          offer Green, Platinum and Black Charter Member NFTs. Platinum and Black NFTs will be scarce.
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip6} alt="Avatar" />
                        <h5 className="flip-card-front-text">GAS-FREE-TRADING</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          Assets traded on the I Got It Crypto Ledger will be free of gas costs prevalent on other
                          platforms.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip7} alt="Avatar" />
                        <h5 className="flip-card-front-text">PROMPT PAYOUTS</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          I Got It has integrations with established payment processors like PayPal/Venmo ensuring funds
                          will be readily available for disbursement.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="single-image">
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <img src={flip8} alt="Avatar" />
                        <h5 className="flip-card-front-text">BLOCKCHAIN AGNOSTIC</h5>
                      </div>
                      <div className="flip-card-back">
                        <img src={overlay} alt="" />
                        <p className="overlay-text">
                          I Got It is Beta testing portability of its NFTs to a number of third-party public blockchains
                          including Ethereum, Wax, and Phantasma.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section> */}
        {/* <section>
          <div className="device-mashup container text-center pt-5 mt-5">
            <h1 className={this.props.AuthStore.dark_model_toggle ? 'mb-3 mobile-font' : 'darkmode mb-3 mobile-font'}>
              I GOT IT IS EVERYWHERE
            </h1>
            <img className="macImg" src={app1} alt="" />
          </div>
          <div className="container text-center mb-4">
            <p
              className={
                this.props.AuthStore.dark_model_toggle
                  ? 'container text-center pt-5'
                  : 'darkmode container text-center pt-5'
              }
            >
              <h3
                className={this.props.AuthStore.dark_model_toggle ? 'mobile-font' : 'darkmode mobile-font'}
                style={{ marginBottom: '-20px' }}
              >
                We deliver our solutions on our web and in mobile app.
              </h3>
              <br />
              Our marketplaces can also be found in a number of our NFL
              <br />
              and NBA team partners' web and mobile apps
            </p>
          </div>
          <div className="play-stores text-center d-flex justify-content-center py-5">
            <a
              href={'https://play.google.com/store/apps/details?id=com.igotitinc.igotitapp&hl=en_US&gl=US'}
              target="_blank"
            >
              <div>
                <img src={app2} alt="" />
              </div>
            </a>

            <a href={'https://apps.apple.com/us/app/igot-it-app/id1457206811'} target="_blank">
              <div>
                <img src={app3} alt="" />
              </div>
            </a>
            <a href={'https://www.igotitapp.com/'} target="_blank">
              <div>
                <img src={app4} alt="" />
              </div>
            </a>
          </div>
        </section> */}
        {/* <section> */}
        {/* <div className="container pt-5 mt-5 text-center" style={{ padding: '4%' }}>
            <h1
              className={this.props.AuthStore.dark_model_toggle ? 'mobile-font' : 'darkmode mobile-font'}
              style={{ margin: '50px' }}
            >
              FOLLOW US ON INSTAGRAM
            </h1>
          </div> */}
        {/* <div className="container-fluid text-center mb-5 pb-5">
            <div id="recipeCarousel" className="carousel slide w-100 pt-5" data-ride="carousel">
              <div className="insta-slider-desktop carousel-inner w-100" role="listbox">
                <div className="carousel-item row no-gutters active"> */}
        {/* <div className="row justify-content-center" id="instagram">
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href="https://www.instagram.com/stories/highlights/17904113326710110/" target="_blank">
                    <img className="img-fluid insta-img" src={insta1} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href="https://www.instagram.com/stories/highlights/17967101947370328/" target="_blank">
                    <img className="img-fluid  insta-img" src={insta2} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href="https://www.instagram.com/stories/highlights/17986691491316383/" target="_blank">
                    <img className="img-fluid  insta-img" src={insta3} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href=" https://www.instagram.com/stories/highlights/17861518052127422/" target="_blank">
                    <img className="img-fluid  insta-img" src={insta4} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href="https://www.instagram.com/stories/highlights/17868688411899244/" target="_blank">
                    <img className="img-fluid insta-img" src={insta5} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-6 float-left pr-1">
              <div className="d-flex justify-content-center">
                <div className="insta-feed">
                  <a href="https://www.instagram.com/stories/highlights/18154488361028925/" target="_blank">
                    <img className="img-fluid insta-img" src={insta6} />
                  </a>
                </div> */}
        {/* </div>
                    </div>
                  </div>
                </div> */}

        {/*
                <a
                  className="carousel-control-prev"
                  href="#recipeCarousel"
                  role="button"
                  data-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Previous</span>
                </a>
                <a
                  className="carousel-control-next"
                  href="#recipeCarousel"
                  role="button"
                  data-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Next</span>
                </a> */}
        {/* </div>
            </div>
          </div>
        </section> */}
        {/* <section>
          <div className="container pt-5 mt-5 text-center mb-5">
            <h1
              className={this.props.AuthStore.dark_model_toggle ? 'mobile-font' : 'darkmode mobile-font'}
              style={{ margin: '50px' }}
            >
              FOLLOW US ON TWITTER
            </h1>
          </div>
          <div className="twiter-img text-center pt-5">
            <TwitterTimelineEmbed
              sourceType="url"
              url="https://twitter.com/metabilia_io"
              options={{ width: 600, tweetLimit: 1 }}
            />
          </div>
        </section> */}
        {/* <ModalBody>
          <div className="col-md-7 text-white">
            <ul className="ul_styles">
              <li className="li_styles">About Us</li>
              <li className="li_styles">Why I Got It</li>
              <li className="li_styles">FAQ</li>
              <li className="li_styles">Press & Fans</li>
              <li className="li_styles">Careers</li>
              <li className="li_styles">Contact Us</li>
            </ul>
          </div>
        </ModalBody> */}
        {this.state.careers == true ? (
          <Modal
            title={this.state.head_title}
            visible={this.state.isModalVisible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={null}
            bodyStyle={{
              backgroundColor: `${this.props.AuthStore.dark_model_toggle == false ? 'black' : 'white'}`,
              border: '1px solid white',
            }}
          >
            <Spin spinning={this.state.loading1}>
              <form onSubmit={this.onSubmit}>
                <div className="row justify-content-center" style={{}}>
                  <p
                    className={
                      this.props.AuthStore.dark_model_toggle == false
                        ? 'modal-text modal-fonts-mobile text-center'
                        : 'modal-fonts-mobile text-center'
                    }
                  >
                    {' '}
                    I Got It is hiring! If you are interested in employment in a fast-growing sports technology company,
                    please enter your details below. We will contact you shortly!
                  </p>
                </div>
                <div className="row justify-content-center" style={{ paddingTop: '6%' }}>
                  <label
                    className={this.props.AuthStore.dark_model_toggle == false ? ' label-style' : 'label-style'}
                    htmlFor="nickname"
                  >
                    Name
                  </label>
                  <div className="form-group form_style_careers">
                    <div className="input-group input_style_careers">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          {/* <span className="fa fa-user ml-3" style={{ color: '#b9b9b9', fontSize: '16px' }}></span> */}
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        style={{ borderLeft: '0px' }}
                        name="c_name"
                        value={this.state.c_name}
                        onChange={this.onChangeInputData}
                        placeholder="Enter Name"
                        required="required"
                      />
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <label
                    className={this.props.AuthStore.dark_model_toggle == false ? 'label-style' : 'label-style'}
                    htmlFor="nickname"
                  >
                    Email
                  </label>
                  <div className="form-group form_style_careers">
                    <div className="input-group input_style_careers">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          {/* <span className="fa fa-user ml-3" style={{ color: '#b9b9b9', fontSize: '16px' }}></span> */}
                        </span>
                      </div>
                      <input
                        type="email"
                        className="form-control"
                        style={{ borderLeft: '0px' }}
                        name="c_email"
                        value={this.state.c_email}
                        onChange={this.onChangeInputData}
                        placeholder="Enter Email"
                        required="required"
                      />
                    </div>
                  </div>
                </div>
                <ReCAPTCHA
                  className="row justify-content-center recaptcha-layout mt-5"
                  ref={(e) => (this.captcha = e)}
                  sitekey="6LcmPEMlAAAAAMMg2hbd0G0px_uUmVRhfP4kxhi9"
                  onChange={this.onChangeReCaptcha}
                />
                {this.state.disable_submit_button ? (
                  <div className="row justify-content-center mt-5">
                    <button
                      type="submit"
                      className={
                        this.props.AuthStore.dark_model_toggle == false
                          ? ' account socialbtn modal-submit-dark'
                          : ' account socialbtn modal-submit'
                      }
                      style={{ position: 'absolute', bottom: '-46%' }}
                    >
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="row justify-content-center mt-5">
                    <button
                      type="submit"
                      className={
                        this.props.AuthStore.dark_model_toggle == false
                          ? ' modal-submit-dark-disable'
                          : ' modal-submit-disable'
                      }
                      style={{ position: 'absolute', bottom: '-46%' }}
                      disabled
                    >
                      Submit
                    </button>
                  </div>
                )}
              </form>
            </Spin>
          </Modal>
        ) : (
          <Modal
            title={this.state.head_title}
            visible={this.state.isModalVisible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={null}
            bodyStyle={{
              backgroundColor: `${this.props.AuthStore.dark_model_toggle == false ? 'black' : 'white'}`,
              border: '1px solid white',
            }}
          >
            <Spin spinning={this.state.loading1}>
              {this.state.press_and_fans == true ? (
                <>
                  {data.press_items.map((pi) => (
                    <div className="row justify-content-center mb-4">
                      <div className="col-md-6">
                        <div className="link-preview" style={{ marginBottom: '5rem' }}>
                          <LinkPreview url={pi.url} />
                        </div>
                        <p></p>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <h1
                  className={!this.props.AuthStore.dark_model_toggle ? 'backend_text_dark ' : 'backend_text_normal '}
                  dangerouslySetInnerHTML={{ __html: this.state.data }}
                ></h1>
              )}
            </Spin>
          </Modal>
        )}
        <Footer />
        <section>
          <div className="row no-gutters text-center mb-4 copy-rights" style={{ padding: '5rem' }}>
            <p className={this.props.AuthStore.dark_model_toggle ? '' : 'darkmode'}>
              <i className="fa  fab fa-copyright"></i> {new Date().getFullYear()} I Got It - All Rights Reserved
            </p>
          </div>
        </section>
      </Spin>
    );
  }
}

export default Login;
